export enum TypeKeys {
    ON_CHANGE = 'ON_CHANGE',
    ON_INIT = 'ON_INIT',
    ON_READY = 'ON_READY',
    ON_SUBMIT = 'ON_SUBMIT',
    RESET_FORM = 'RESET_FORM',
    SUBMIT_COMPLETE = 'SUBMIT_COMPLETE',
    SUBMIT_WORD = 'SUBMIT_WORD',
}